import React, { useEffect, useState } from 'react';

import { Cancel, CheckCircle } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';

const COACH_ROLES = {
  mentor: 'Mentor',
  career_coach: 'Career Coach',
  instructor: 'Instructor',
  subject_matter_expert: 'Subject Matter Expert',
  evaluator: 'Evaluator',
  moderator: 'Moderator',
  alumni: 'Alumni',
  writer: 'Technical Writer',
};

const Gigs = ({ data, setData, gigs, setDisableSave, disableSave }) => {
  const [verify, setVerify] = useState({});
  const [gigData, setGigData] = useState([]);

  useEffect(() => {
    if (Object.keys(verify).length > 0) {
      if (gigs?.length === Object.keys(verify).length) {
        setDisableSave({ ...disableSave, gigs: false });
      } else {
        setDisableSave({ ...disableSave, gigs: true });
      }
    }
  }, [verify]);

  useEffect(() => {
    if (gigData.length > 0) {
      setData({
        ...data,
        gigs: [...gigData],
      });
    }
  }, [gigData]);

  return (
    <>
      <div className=' ounded-lg col-span-3 bg-white'>
        {/* </div> */}
        <div className='flex flex-col space-y-0 justify-center w-full py-6'>
          <div className=' font-semibold ml-4 mb-4'>Choose your Gig</div>
          {gigs?.length > 0 &&
            gigs.map((exp, index) => {
              return (
                <div className='flex items-center gap-14  px-4' key={index}>
                  <span className=' flex items-center w-3/4'>
                    <span className='ml-2'>
                      <div className=' flex flex-col space-y-1'>
                        <div className=' opacity-80 text-base'>
                          {COACH_ROLES[exp]}
                        </div>
                      </div>
                    </span>
                  </span>
                  <span className='w-1/4 flex items-center justify-between'>
                    <span className=' opacity-60 text-sm'>
                      {verify[index] === 'yes' && 'Approve'}
                      {verify[index] === 'no' && 'Reject'}
                    </span>
                    <span>
                      <IconButton
                        onClick={() => {
                          setVerify({ ...verify, [index]: 'yes' });
                          gigData.splice(index, 0, exp);
                          setGigData([...gigData]);
                        }}
                        className='focus:outline-none'
                      >
                        <CheckCircle
                          htmlColor={
                            verify[index] === 'yes' ? '#76CE65' : 'inherit'
                          }
                        />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          setVerify({ ...verify, [index]: 'no' });
                          gigData.splice(index, 1);
                          setGigData([...gigData]);
                        }}
                      >
                        <Cancel
                          htmlColor={
                            verify[index] === 'no' ? '#CC0000' : 'inherit'
                          }
                        />
                      </IconButton>
                    </span>
                  </span>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default Gigs;
